import { gql } from '@apollo/client';
import {
  useEndShiftOnLogoutMutation,
  useGetCurrentShiftForLogoutQuery,
} from './__generated__/useSidebarSetingsMenuEmployeeLogoutButtonState.generated';
import { useHotToast } from 'src/utils/useHotToast';
import { useAuthContext } from 'src/Components/AuthContext';

export function useSidebarSetingsMenuEmployeeLogoutButtonState() {
  const { data, isGettingShift } = useGetCurrentShift();
  const { endShift, isEndingShift } = useEndShift();
  return {
    isGettingShift,
    currentShift: Boolean(data?.getCurrentShift),
    isEndingShift: isEndingShift,
    endShift: endShift,
  };
}

function useGetCurrentShift() {
  const toast = useHotToast();
  const authContext = useAuthContext();
  const { data, loading } = useGetCurrentShiftForLogoutQuery({
    fetchPolicy: 'network-only',
    onError: error => {
      toast.error('Could not get current shift.');
    },
    skip: !Boolean(authContext.user?.employee?.id),
  });
  return {
    data,
    isGettingShift: loading,
  };
}

const query = gql`
  query GetCurrentShiftForLogout {
    getCurrentShift {
      id
      startTime
      endTime
    }
  }
`;

function useEndShift() {
  const toast = useHotToast();
  const [endShiftMutation, { loading: isEndingShift }] =
    useEndShiftOnLogoutMutation({
      onError: e => {
        toast.error(e.message);
      },
    });
  return {
    isEndingShift,
    endShift: (onShiftEnded: () => void) => {
      endShiftMutation({
        onCompleted: onShiftEnded,
      });
    },
  };
}

const mutation = gql`
  mutation EndShiftOnLogout {
    employeeEndShift {
      id
      startTime
    }
  }
`;
